// src/pages/EditConnectionPage.js
import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';

const EditConnectionPage = () => {
  const navigate = useNavigate();
  const user = supabase.auth.user();

  const [loading, setLoading] = useState(true);
  
  // Form fields
  const [profilePic, setProfilePic] = useState('');
  const [facebook, setFacebook] = useState('');
  const [twitter, setTwitter] = useState('');
  const [instagram, setInstagram] = useState('');
  const [website, setWebsite] = useState('');
  const [websiteIcon, setWebsiteIcon] = useState('');
  const [about, setAbout] = useState('');
  const [call, setCall] = useState('');
  const [emailField, setEmailField] = useState('');
  const [textField, setTextField] = useState('');
  const [pictures, setPictures] = useState([{ image_url: '', heading: '', description: '' }]);

  useEffect(() => {
    const fetchUserCard = async () => {
      if (!user) {
        navigate('/login');
        return;
      }
      const { data, error } = await supabase
        .from('cards')
        .select('*')
        .eq('user_id', user.id)
        .single();
      if (error) {
        console.error('Error fetching user card:', error);
      } else if (data) {
        setProfilePic(data.profile_pic || '');
        const social = data.social_links || {};
        setFacebook(social.facebook || '');
        setTwitter(social.twitter || '');
        setInstagram(social.instagram || '');
        setWebsite(social.website || '');
        setWebsiteIcon(social.websiteIcon || '');
        setAbout(data.about || '');
        setCall(data.call || '');
        setEmailField(data.email || '');
        setTextField(data.text || '');
        setPictures(data.pictures || [{ image_url: '', heading: '', description: '' }]);
      }
      setLoading(false);
    };
    fetchUserCard();
  }, [user, navigate]);

  const handlePictureChange = (index, field, value) => {
    const newPictures = [...pictures];
    newPictures[index][field] = value;
    setPictures(newPictures);
  };

  const addPicture = () => {
    setPictures([...pictures, { image_url: '', heading: '', description: '' }]);
  };

  const removePicture = (index) => {
    const newPictures = pictures.filter((_, i) => i !== index);
    setPictures(newPictures);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!user) return;

    const updatedData = {
      profile_pic: profilePic,
      social_links: { facebook, twitter, instagram, website, websiteIcon },
      about,
      call,
      email: emailField,
      text: textField,
      pictures,
    };

    const { data, error } = await supabase
      .from('cards')
      .update(updatedData)
      .eq('user_id', user.id);

    if (error) {
      console.error('Error updating card:', error);
    } else {
      const redirectSlug = data[0].custom_slug || data[0].uuid;
      navigate(`/${redirectSlug}`);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="edit-connection-page">
      <h2>Edit Connection Page</h2>
      <form onSubmit={handleUpdate}>
        <div>
          <label>Profile Picture URL:</label>
          <input
            type="text"
            value={profilePic}
            onChange={(e) => setProfilePic(e.target.value)}
          />
        </div>

        {/* Social Links */}
        <div>
          <h3>Social Links</h3>
          <label>Facebook:</label>
          <input
            type="text"
            value={facebook}
            onChange={(e) => setFacebook(e.target.value)}
          />
          <br />
          <label>Twitter:</label>
          <input
            type="text"
            value={twitter}
            onChange={(e) => setTwitter(e.target.value)}
          />
          <br />
          <label>Instagram:</label>
          <input
            type="text"
            value={instagram}
            onChange={(e) => setInstagram(e.target.value)}
          />
          <br />
          <label>Personal Website:</label>
          <input
            type="text"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
          />
          <br />
          <label>Website Icon:</label>
          <select value={websiteIcon} onChange={(e) => setWebsiteIcon(e.target.value)}>
            <option value="">Select Icon</option>
            <option value="globe">Globe</option>
            <option value="user">User</option>
            <option value="custom">Custom</option>
          </select>
        </div>

        {/* About Section */}
        <div>
          <h3>About</h3>
          <textarea value={about} onChange={(e) => setAbout(e.target.value)} />
        </div>

        {/* Contact Section */}
        <div>
          <h3>Contact</h3>
          <label>Call:</label>
          <input
            type="text"
            value={call}
            onChange={(e) => setCall(e.target.value)}
          />
          <br />
          <label>Email:</label>
          <input
            type="email"
            value={emailField}
            onChange={(e) => setEmailField(e.target.value)}
          />
          <br />
          <label>Text:</label>
          <input
            type="text"
            value={textField}
            onChange={(e) => setTextField(e.target.value)}
          />
        </div>

        {/* Pictures Section */}
        <div>
          <h3>Pictures</h3>
          {pictures.map((pic, index) => (
            <div key={index}>
              <label>Image URL:</label>
              <input
                type="text"
                value={pic.image_url}
                onChange={(e) => handlePictureChange(index, 'image_url', e.target.value)}
              />
              <br />
              <label>Heading:</label>
              <input
                type="text"
                value={pic.heading}
                onChange={(e) => handlePictureChange(index, 'heading', e.target.value)}
              />
              <br />
              <label>Description:</label>
              <textarea
                value={pic.description}
                onChange={(e) => handlePictureChange(index, 'description', e.target.value)}
              />
              <br />
              <button type="button" onClick={() => removePicture(index)}>
                Remove Picture
              </button>
            </div>
          ))}
          <button type="button" onClick={addPicture}>Add Picture</button>
        </div>

        <button type="submit">Update Connection</button>
      </form>
    </div>
  );
};

export default EditConnectionPage;
